<lib-form-field-container
    [isOptional]="isOptional"
    [kind]="FormContainerKind.TextArea"
    [textKind]="textKind">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-content
        menu
        select="[menu]"></ng-content>

    @if (prefixIcon) {
        <ng-container prefixIcon>
            <lib-icon [icon]="prefixIcon"></lib-icon>
        </ng-container>
    }

    @if (suffixIcon) {
        <ng-container suffixIcon>
            <lib-icon [icon]="suffixIcon"></lib-icon>
        </ng-container>
    }

    <ng-content
        bottomMenu
        select="[bottomMenu]"></ng-content>

    <textarea
        #textareaRef
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [ngClass]="{ 'text-area-code-block-font': textKind == TextKind.CodeBlock }"
        wrap="hard"
        [formControl]="viewControl"
        [placeholder]="placeholderText"
        [attr.autocorrect]="autocorrect ? 'on' : 'off'"
        [autocomplete]="autocorrect ? 'on' : 'off'"
        [spellcheck]="autocorrect"
        [attr.data-sb-qa]="qaTag"
        (blur)="OnBlur()"
        (change)="$event.stopPropagation()"></textarea>
</lib-form-field-container>
